export const GET_USERS = 'GET_USERS';
export const GET_GOALS = 'GET_GOALS';
export const CREATE_USER = 'CREATE_USER';
export const EDIT_USER = 'EDIT_USER';
export const DELETE_USER = 'DELETE_USER';
export const CREATE_GOAL = 'CREATE_GOAL';
export const EDIT_GOAL = 'EDIT_GOAL';
export const DELETE_GOAL = 'DELETE_GOAL';
export const GET_REVIEWS = 'GET_REVIEWS';
export const CREATE_REVIEW = 'CREATE_REVIEW';
export const GET_EVALUATION_DATA = 'GET_EVALUATION_DATA';
export const GET_DIRECT_REPORTS = 'GET_DIRECT_REPORTS';
export const GET_SCORE = 'GET_SCORE';